import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Layout from './components/Layout';
import SEO from './components/SEO';
import HomePage from './pages/HomePage';
import AboutPage from './pages/AboutPage';
import OpenSourcePage from './pages/OpenSourcePage';
import SolutionsPage from './pages/SolutionsPage';
import MonitoringPage from './pages/MonitoringPage';
import SupportPage from './pages/SupportPage';
import InfraPage from './pages/InfraPage';
import SecurityPage from './pages/SecurityPage';
import OpenSourceInfraPage from './pages/OpenSourceInfraPage';
import OpenSourceDBPage from './pages/OpenSourceDBPage';
import CommercialDBPage from './pages/CommercialDBPage';
import DownloadPage from './pages/DownloadPage';


function App() {
  return (
    <Router>
      <SEO 
        title="제스트정보기술" 
        description="오픈소스, IT인프라 소프트웨어, 성능모니터링 전문기업"
      />
      <Layout>
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/about" element={<AboutPage />} />
          <Route path="/opensource" element={<OpenSourcePage />} />
          <Route path="/solutions" element={<SolutionsPage />} />
          <Route path="/monitoring" element={<MonitoringPage />} />
          <Route path="/support" element={<SupportPage />} />
          <Route path="/infra" element={<InfraPage />} />
          <Route path="/security" element={<SecurityPage />} />
          <Route path="/opensource-infra" element={<OpenSourceInfraPage />} />
          <Route path="/opensource-db" element={<OpenSourceDBPage />} />
          <Route path="/commercial-db" element={<CommercialDBPage />} />
		  <Route path="/down" element={<DownloadPage />} />
        </Routes>
      </Layout>
    </Router>
  );
}

export default App;
